import { ErrorPageComponent } from './error-page/error-page.component';
import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { HomePageComponent } from './home/home.page.component';
// import { CmsStudioComponent } from './cms/cmsstudio/cmsstudio.component';




/* 
Don't use loadChildren: () => ProductDetailModule. 
Don't do that, prod build will fail, this is just a workaround.
Disable Angular Lazy Load Modules as it is not working in our application. Will inspect in the future if find solution to fix the bugs. 
*/
const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: 'dashboard',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        component: HomePageComponent,
    },
    {
        path: '404',
        component: ErrorPageComponent,
        data: {
            breadcrumb:'404',
        }
    },
    // {
    //     path: '**',
    //     component: ErrorPageComponent,
    //     data: {
    //         breadcrumb:'404',
    //     }
    // },
    // {
    //     path: 'myOrder',
    //     loadChildren: './my-orders/my-order.module#MyOrderModule',
    // },
    // {
    //     path: 'buy',
    //     loadChildren: './buy/buy.page.module#BuyPageModule',
    // },
    // {
    //     path: 'quotes',
    //     loadChildren: './quotes/quotes.module#QuotesModule'
    // },
    // {
    //     path: 'renewals',
    //     loadChildren: './renewals/renewals.module#RenewalsModule'
    // },
    // {
    //     path: 'subscriptions',
    //     loadChildren: './subscriptions/subscriptions.module#SubscriptionModule'
    // },
    // {
    //     path: 'myAccount',
    //     loadChildren: './my-account/my-account.module#MyAccountModule'
    // },
    // {
    //     path: 'myCarts',
    //     loadChildren: './my-carts/my-carts.module#MyCartsModule'
    // },
    // {
    //     path: 'aboutInfo',
    //     loadChildren: './about-info/about-info.module#AboutInfoModule'
    // },
    // {
    //     path: 'product',
    //     loadChildren: './product/product.detail.module#ProductDetailModule'
    // },
    // {
    //     path: 'reporting',
    //     loadChildren: './reporting/reporting.module#ReportingModule'
    // },
    // {
    //     path: 'promotions',
    //     loadChildren: './promotions/promotions.module#PromotionsModule'
    // },
    // {
    //     path: 'tools',
    //     loadChildren: './tools/tools.module#ToolsModule'
    // },
    // {
    //     path: 'catalogues',
    //     loadChildren: './catalogues/catalogues.module#CataloguesModule'
    // },
    // {
    //     path: 'events',
    //     loadChildren: './events/events.module#EventsModule'
    // },
    // {
    //     path: 'kb',
    //     loadChildren: './kb/kb.module#KbModule'
    // },
    // {
    //     path: 'microsites',
    //     loadChildren: './microsites/microsites.module#MicrositesModule'
    // },
    // {
    //     path: 'admin',
    //     loadChildren: './admin/admin.module#AdminModule'
    // },

    {
        path: 'cms',
        loadChildren: () => import('./cms/cms.module').then(x => x.CmsStudioModule)
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(x => x.AdminModule)
    }

];

export const RoutingModule: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes);
